var render, staticRenderFns
import script from "./InterfaceText.vue?vue&type=script&lang=js"
export * from "./InterfaceText.vue?vue&type=script&lang=js"
import style0 from "./InterfaceText.vue?vue&type=style&index=0&id=5a82dc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82dc74",
  null
  
)

export default component.exports